/**
 * Request builders for custom creator endpoints not covered by generic JSON:API utilities.
 */

export function getCreatorContentSources(id: string) {
  return { url: `/api/creators/${encodeURIComponent(id)}/videos` };
}
